import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { Loader2 } from 'lucide-react';

const AnalyzingScreen = () => {
  const { setCurrentScreen } = useApp();
  const [currentInsight, setCurrentInsight] = useState(0);
  
  const educationalInsights = [
    "Natural fibers like cotton and linen are biodegradable and breathable.",
    "Synthetic fabrics shed microplastics that pollute our oceans.",
    "Organic certification means no toxic pesticides were used.",
    "A garment's true cost includes environmental and social impact.",
    "Recycled materials reduce waste but quality varies by process.",
    "Wool is naturally flame-resistant and temperature-regulating.",
    "Lyocell (Tencel) is made from sustainable wood pulp.",
    "Cashmere production can lead to overgrazing and desertification.",
    "Hemp requires minimal water and no pesticides to grow.",
    "Polyester is derived from petroleum and takes 200+ years to decompose."
  ];

  useEffect(() => {
    // Rotate insights every 5 seconds to keep user engaged
    const insightInterval = setInterval(() => {
      setCurrentInsight(prev => (prev + 1) % educationalInsights.length);
    }, 5000);

    // NO automatic navigation - let parent component (ScanScreenQuadrant) navigate when API completes
    // This ensures we only navigate when real data is ready

    return () => {
      clearInterval(insightInterval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white pb-24 flex flex-col items-center justify-center px-6">
      {/* Large Atelia Logo */}
      <div className="mb-12">
        <img 
          src="/logos/logo-black.jpg" 
          alt="ATELIA" 
          className="h-32 w-auto object-contain opacity-90"
        />
      </div>

      {/* Loading Spinner */}
      <div className="mb-8">
        <Loader2 size={48} className="text-black animate-spin" />
      </div>

      {/* Title */}
      <h2 className="text-3xl font-bold text-black mb-3 uppercase tracking-wide text-center">
        Analyzing...
      </h2>

      {/* Subtitle */}
      <p className="text-black/72 text-center text-sm mb-12 max-w-xs uppercase tracking-wide font-semibold">
        Extracting fabric intelligence
      </p>

      {/* Educational Insight - Rotates every 5 seconds */}
      <div className="max-w-sm bg-black/5 rounded-xl p-5 border border-black/12">
        <div className="flex items-start gap-3">
          <span className="text-2xl flex-shrink-0">💡</span>
          <div>
            <p className="text-xs uppercase font-bold text-black/55 mb-2">DID YOU KNOW?</p>
            <p className="text-sm text-black/80 leading-relaxed">
              {educationalInsights[currentInsight]}
            </p>
          </div>
        </div>
      </div>

      {/* Progress Indicator */}
      <div className="mt-8 text-xs text-black/40 uppercase tracking-wide">
        Analyzing garment details...
      </div>
    </div>
  );
};

export default AnalyzingScreen;
